import $ from "jquery";

export const popover = {
  inserted: function (el) {
    $.fn.tooltip.Constructor.Default.whiteList["*"].push("style");
    $(el).popover({
      html: true,
      trigger: "focus",
      container: "body",
      toggle: "popover",
      placement: "top",
      boundary: "viewport",
      content: function () {
        var content = $(this).attr("data-popover-content");
        return $(content).children(".popover-body").html();
      },
    });
  },
};

export const btooltip = {
  inserted: function (el) {
    $(el).tooltip({
      placement: "top",
      container: "body",
      trigger: "hover",
      boundary: "viewport",
      title: function () {
        return $(this).attr("tooltip");
      },
    });
  },
  unbind(el) {
    $(el).tooltip("dispose");
  },
};
